import * as Yup from "yup";

const firstSchema = Yup.object().shape({
  cpfCnpj: Yup.string().required("*O CNPJ é obrigatório"),
  nome: Yup.string().required("*O Nome é obrigatório"),
  nomeFantasia: Yup.string().required("*O Nome fantasia é obrigatório"),
});

export default firstSchema;
